import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", function () {
    window.closeMobileForm = (form) => {
        let tl = gsap.timeline()
        tl.to(form, {left: "100%", duration: .5})
        tl.to(form, {display : "none"})
        
        if(opensForm.length === 0) {
            tl.to(orderMobile, {overflow: "visible", display: "block"})
            gsap.to(menuMobile, {display: "block"})
        }
    }

    window.openMobileForm = (form) => {
        let tl = gsap.timeline()
        tl.to(form, {display: "block"})
        tl.to(form, {left: "0%", duration: .5})
        tl.to(orderMobile, {overflow: "hidden", display: "none"}, .5)
        gsap.to(menuMobile, {display: "none"}) 
    }

    let opensForm = []
    const orderMobile = document.querySelector('.order-mobile')
    const menuMobile = document.querySelector('.menu-mobile')
    const hrefOrder = document.querySelectorAll("[data-open-form]")
    const hrefClose = document.querySelectorAll(".order-mobile__close");
    const hrefCloseAll = document.querySelectorAll(".order-mobile__close-all")
    const forms = document.querySelectorAll('[data-form]')
    const mobileMapSection = document.querySelectorAll('.order-mobile__map-section')

    hrefOrder.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault()
            const openForm = item.getAttribute('data-open-form');
            const form = Object.values(forms).find(form => form.getAttribute('data-form') === openForm)
            openMobileForm(form)
            opensForm.push(form)

            if(mobileMapSection.length) {
                mobileMapSection.forEach((mapSection) => {
                    const blockMap = mapSection.querySelector('.making-order__map-block');
                    const hideMap = mapSection.querySelector('.order-mobile__map-hide');
        
                    blockMap.style.height = "0px";
                    blockMap.style.opacity = "0";
                    hideMap.style.display = "none";
                })
            }
        })    
    })

    hrefClose.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault()
            const orderMobileForm = e.target.closest(".order-mobile__form");
            opensForm = opensForm.filter(form => form != orderMobileForm);
            if(opensForm.length == 0) orderMobile.style.display = "block";
            closeMobileForm(orderMobileForm)
        })
    })

    hrefCloseAll.forEach((item) =>{
        item.addEventListener("click", (e) => {
            e.preventDefault()
            opensForm = []
            orderMobile.style.display = "block"
            forms.forEach(item => closeMobileForm(item));
        })
    }) 
});